import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"

import { Provider } from "react-redux"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

import store from "./store"

const queryClient = new QueryClient()

const path = (window.location.pathname || "").toLowerCase()
const deferI18n =
  path === "/login" ||
  path.startsWith("/login/") ||
  path === "/forgot-password" ||
  path === "/resetpassword"

if (!deferI18n) {
  require("./i18n")
}

const app = (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()
